import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {DartDealImportDialogComponent} from "./dartDealImport-dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {createEvent} from "../misc/event.polyfill";
import {UrlParams} from "../http/url-params-serializer";

@Directive({
  selector: "[importDartDeal]",
})
export class DartDealImportDirective {
  @Input()
  params: UrlParams;

  @Input()
  stopPropagation: boolean;

  @Input()
  projectId: string;

  @Input()
  targetSystem: string;

  @Input()
  CPQSource: boolean;

  @Output("closed")
  public closedEmitter: EventEmitter<Event> = new EventEmitter();

  constructor(private el: ElementRef, private dialogService: DialogService) {
    if (el.nativeElement.tagName === "A" && el.nativeElement.href === "") {
      el.nativeElement.href = "#";
    }
  }

  @HostListener("click", ["$event"])
  click(event: Event) {
    event.preventDefault();
    const dialog = this.dialogService.addDialog(
      DartDealImportDialogComponent,
      {projectId: this.projectId, targetSystem: this.targetSystem , CPQSource: this.CPQSource},
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );

    dialog.subscribe(
      (result: boolean) => {
        const closedEvent = createEvent("DartDealValidatorDialogClosedEvent");
        closedEvent["value"] = result;
        this.closedEmitter.emit(closedEvent);
      },
    );

    if (this.stopPropagation) {
      event.stopPropagation();
      return false;
    }

    return true;
  }
}
